import type { ReactNode } from "react";

// Shared by the Health page's panels (OMG-2767).

export const REFRESH_MS = 60_000;

export const Panel = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <section className="border rounded-lg bg-white p-4">
    <h2 className="text-sm font-semibold text-gray-700 mb-3">{title}</h2>
    {children}
  </section>
);

const errorText = (error: unknown) =>
  error instanceof Error ? error.message : String(error);

export const ErrorLine = ({ error }: { error: unknown }) => (
  <p className="text-sm text-red-700">Could not load: {errorText(error)}</p>
);

// A failed background refresh keeps the last good data on screen (react-query
// keeps `data` when a refetch fails) and says so, rather than blanking the panel.
export const RefreshFailed = ({ error }: { error: unknown }) => (
  <p className="text-xs text-amber-700 mb-2">
    Refresh failed ({errorText(error)}); showing the last data loaded.
  </p>
);
